/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
export const JiraIcon = ({size, ...props}) => (
  <svg viewBox="0 0 14 14" fill="currentColor" width={ size || "14" } height={ size || "14" } {...props}>
    <defs>
      <linearGradient id="tuefbtq0aa" x1="71.361%" x2="38.91%" y1="40.328%" y2="81.66%">
        <stop offset="18%" stopColor="#0052CC" />
        <stop offset="100%" stopColor="#2684FF" />
      </linearGradient>
      <linearGradient id="am7k5lghxb" x1="28.934%" x2="61.348%" y1="59.166%" y2="17.99%">
        <stop offset="18%" stopColor="#0052CC" />
        <stop offset="100%" stopColor="#2684FF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="nonzero">
      <path fill="#2684FF" d="M13.832 6.608L7.604.584 7 0 2.311 4.535.168 6.608c-.224.217-.224.567 0 .784l4.283 4.143L7 14l4.689-4.535.072-.07 2.071-2.003c.224-.217.224-.567 0-.784zM7 9.07L4.86 7 7 4.93 9.14 7 7 9.07z"
      />
      <path fill="url(#tuefbtq0aa)" d="M7 4.919C5.509 3.562 5.502 1.365 6.984 0L2 4.532 4.712 7 7 4.919z" />
      <path fill="url(#am7k5lghxb)" d="M9.285 7L7 9.074c.72.653 1.125 1.539 1.125 2.463 0 .924-.405 1.81-1.125 2.463l5-4.537L9.285 7z" />
    </g>
  </svg>
);
JiraIcon.displayName = 'JiraIcon';
JiraIcon.propTypes = {
  size: PropTypes.string
}
/* tslint:enable */
/* eslint-enable */
